import { render, staticRenderFns } from "./forger-password.vue?vue&type=template&id=999376e6&scoped=true"
import script from "./forger-password.vue?vue&type=script&lang=js"
export * from "./forger-password.vue?vue&type=script&lang=js"
import style0 from "./forger-password.vue?vue&type=style&index=0&id=999376e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999376e6",
  null
  
)

export default component.exports